<template>
    <svg width="28" height="23" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 5.86365H19" stroke="#212135" stroke-width="0.818182" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.3636 0.954559H2.63636C1.73262 0.954559 1 1.68718 1 2.59092V12.4091C1 13.3128 1.73262 14.0455 2.63636 14.0455H17.3636C18.2674 14.0455 19 13.3128 19 12.4091V2.59092C19 1.68718 18.2674 0.954559 17.3636 0.954559Z" stroke="#212135" stroke-width="0.818182" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>